import styled from 'styled-components';

export const GlobalLoadingWrapper = styled.div`
  height: 93vh;
  width: 100%;
  position: relative;
  > div {
    position: absolute;
    top: 40vh;
    right: 50vw;
  }
`;
